module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"of the year {year}":"{year}"},"en":{"of the year {year}":"of the Year {year}","Лучшая онлайн платежная система":"Best Online Payment Solution","Лучшая онлайн платежная система 2023":"Online Payment Solution of the Year 2023","Лучший платежный сервис 2023":"Best Payment Solution of the Year 2023","Лучший платежный сервис 2022":"Best Payment Solution of the Year 2022"}}')
  delete Component.options._Ctor
}
